import { Action, Dispatch } from 'redux';
import { Enum } from 'typescript-string-enums';
import {
  IAddress,
  IDuplicateAndQuarantine,
  IProductInfo,
  IUserInfo,
  IUserLoggedIn,
  ProductId
} from '../CustomTypes';
import 'whatwg-fetch';
import { ActionTypes } from "./actionTypes";
/* tslint:disable:max-classes-per-file max-line-length */

export type apiStatuses =
  | 'API_CONFLICT'
  | 'API_ERROR'
  | 'API_LOADING'
  | 'API_SUCCESS'
  | 'VALIDATION_ERROR'
  | 'AGREEMENT_NOT_ACCEPTED';
export const apiStatuses: { [k: string]: apiStatuses } = {
  AGREEMENT_NOT_ACCEPTED: 'AGREEMENT_NOT_ACCEPTED' as apiStatuses,
  CONFLICT: 'API_CONFLICT' as apiStatuses,
  ERROR: 'API_ERROR' as apiStatuses,
  LOADING: 'API_LOADING' as apiStatuses,
  SUCCESS: 'API_SUCCESS' as apiStatuses,
  VALIDATION_ERROR: 'VALIDATION_ERROR' as apiStatuses
};

export class ApiError extends Error {
  public response: string;
  public status: number;
  public errorCode?: number;
  public data: string;
  public requestUuid?: string;
  public requestUrl?: string;
}

export const validationErrors = {
  PURCHASE_FAILED: 'PURCHASE_FAILED',
  STREX_ADDITIONAL_INFORMATION: 'STREX_ADDITIONAL_INFORMATION',
  USER_AGREEMENT_NOT_ACCEPTED: 'USER_AGREEMENT_NOT_ACCEPTED',
};

export interface IExceptionAction extends Action {
  type: exceptionTypes;
  exception: object;
}

export const exceptionTypes = Enum('EXCEPTION');
export type exceptionTypes = keyof typeof exceptionTypes;

export type LogException = (
  type: exceptionTypes,
  exception: object
) => (dispatch: Dispatch<IExceptionAction>) => void;
export const logException: LogException = (type, exception) => dispatch => {
  if (window && window.console) {
    /*tslint:disable:no-console*/
    window.console.log(type, exception);
  }
  dispatch({ type, exception });
};

export class Deferred<T> {
  public reject: (reason?: any) => any;
  public resolve: (value?: T | PromiseLike<T> | Response) => any;
  public promise: Promise<T>;

  constructor() {
    this.promise = new Promise<T>((resolve, reject) => {
      this.reject = reject;
      this.resolve = resolve;
    });
  }
}

export const productInfoDeferred: Deferred<IProductInfo> = new Deferred<
  IProductInfo
>();

export type fetchUserInfoDeferred = Deferred<IUserInfo>;
export const fetchUserInfoDeferred: fetchUserInfoDeferred = new Deferred<
  IUserInfo
>();

export type userLoggedInDeferred = Deferred<IUserLoggedIn>;
export const userLoggedInDeferred: userLoggedInDeferred = new Deferred<
  IUserLoggedIn
>();

export type checkDuplicateAndQuarantineDeferred = Deferred<
  IDuplicateAndQuarantine
>;
export const checkDuplicateAndQuarantineDeferred: checkDuplicateAndQuarantineDeferred = new Deferred<
  IDuplicateAndQuarantine
>();
export type ValidateLoyaltyCodeDeferred = (
  lp: string,
  code: string,
  ai?: string
) => (dispatch: Dispatch<Action>) => Promise<Response> | any;

export type FetchApi = (
  url: string,
  actionType: ActionTypes,
  successCallback?: (r: Response | any) => any,
  failedCallback?: (r: Error) => any
) => (dispatch: Dispatch<Action>) => Promise<Response> | any;

export type CheckProductQuarantined = (
  productId: ProductId,
  spidId: number
) => (dispatch: Dispatch<Action>) => Promise<Response>;

export type FetchProductInfo = (
  productId: number | string
) => (dispatch: Dispatch<Action>) => Promise<Response> | any;

export type FetchBrregInfo = (
  orgNumber: string
) => (dispatch: Dispatch<Action>) => any;

export type FetchCustomerServiceInfo = () => (
  dispatch: Dispatch<Action>
) => any;

export type InitializeSpid = () => (dispatch: Dispatch<Action>) => Promise<any>;
export type InitializeSpidBound = () => Promise<any>;

export interface IFindUserByEmailOrPhoneResult {
  createUserEmailSent: boolean;
  loginLinkSent: boolean;
  sendToEmailLogin: boolean;
  sentCodeOnSMS: boolean;
  email: string;
  phone: string;
  message: string;
  hasPhone: boolean;
  hasPaymentMethods: boolean;
  emailVerificationTriggered: boolean;
  statusCode: number;
}
export type FindUserByEmail = (
  email: string,
  linkHasPaymentMethod: string,
  linkNoPaymentMethod?: string
) => (dispatch: Dispatch<Action>) => Promise<IFindUserByEmailOrPhoneResult>;
export type FindUserByEmailBound = (
  email: string,
  linkHasPaymentMethod: string,
  linkNoPaymentMethod?: string,
) => Promise<IFindUserByEmailOrPhoneResult>;

export type FindUserByPhoneNumber = (
  phoneNumber: string,
  email: string,
  linkHasPaymentMethod: string,
  linkNoPaymentMethod?: string
) => (dispatch: Dispatch<Action>) => Promise<IFindUserByEmailOrPhoneResult>;
export type FindUserByPhoneNumberBound = (
  phoneNumber: string,
  email: string,
  linkHasPaymentMethod: string,
  linkNoPaymentMethod?: string
) => Promise<IFindUserByEmailOrPhoneResult>;

export type CheckCode = (
  code: string,
  email: string
) => (dispatch: Dispatch<Action>) => Promise<any>;
export type CheckCodeBound = (code: string, email: string) => Promise<any>;

export type SendSms = (
  email: string
) => (dispatch: Dispatch<Action>) => Promise<any>;

export interface ICompanyPays {
  organizationNumber: string;
  companyName: string;
  reference: string;
  invoiceStreet: string;
  invoiceCity: string;
  invoiceZipCode: string;
}

// tslint:disable-next-line:interface-name
export interface CreateOrderInput {
  companyContactEmail?: string;
  companyContactFirstName?: string;
  companyContactLastName?: string;
  companyContactPhone?: string;
  spidId: number | string;
  sig: string;
  productInfo: IProductInfo;
  paymentMethodId: string;
  phoneNumber: string;
  address: IAddress;
  referer: string;
  redirectUri: string;
  purchasedSubscriptionId: string;
  paymentType: string;
  companyPays?: ICompanyPays;
  loyaltyPartner?: string;
  receiptPageUrl?: string;
  vippsPhoneNumber?: string;
}

// tslint:disable-next-line:interface-name
interface CreateOrderReturnProductChange {
  subscriptionId: string;
  clientReference: string;
  code: string;
}
// tslint:disable-next-line:interface-name
interface CreateOrderReturnFree {
  widgetUrl: string;
  redirectUrl: string;
  paymentId: number;
}
// tslint:disable-next-line:interface-name
export interface CreateOrderReturnVipps {
  redirectUrl: string;
}
// tslint:disable-next-line:interface-name
interface CreateOrderReturnAddCard {
  widgetUrl: string;
  redirectUrl: string;
}
// tslint:disable-next-line:interface-name
interface CreateOrderReturnSentToCrm {
  subscriptionId: string;
  spidOrder: string;
  clientReference: string;
  code: string;
}
export type CreateOrderReturn =
  | CreateOrderReturnProductChange
  | CreateOrderReturnFree
  | CreateOrderReturnVipps
  | CreateOrderReturnAddCard
  | CreateOrderReturnSentToCrm
;
export type CreateOrder = (props: CreateOrderInput) => (dispatch: Dispatch<Action>) => Promise<CreateOrderReturn>;

export type FetchUserInfo = (
  spidId: string,
  sig: string,
  serverTime?: number,
  expiresIn?: number
) => (dispatch: Dispatch<Action>) => Promise<any>;
export type FetchUserInfoBound = (
  spidId: string,
  sig: string,
  serverTime?: number,
  expiresIn?: number
) => Promise<any>;

export interface ICreateSpidUserResult {
  code: number;
  userCreated: boolean;
  loginLinkSent: boolean;
  emailVerificationTriggered: boolean;
  /** SPiD user ID */
  sid: string;
  email: string;
  message: string;
}
export type CreateSpidUser = (
  email: string,
  firstName: string,
  lastName: string,
  phoneNumber: string,
  returnUrl: string,
  birthDate: string,
  address: IAddress
) => (dispatch: Dispatch<Action>) => Promise<ICreateSpidUserResult>;
export type CreateSpidUserBound = (
  email: string,
  firstName: string,
  lastName: string,
  phoneNumber: string,
  returnUrl: string,
  birthDate: string,
  address: IAddress
) => Promise<ICreateSpidUserResult>;

export type CheckDuplicateAndQuarantine = (
  productId: string,
  owningClient: string,
  spidId: string,
  sig: string
) => (dispatch: Dispatch<Action>) => Promise<any>;

export type AddFamilySharing = (
  spidId: number,
  email: string,
  cellPhone: string,
  sig: string,
  referer?: string,
  source?: string,
) => (dispatch: Dispatch<Action>) => Promise<any>;

export type CancelPayment = (
  owningClient: string,
  spidId: number,
  sig: string,
  cause: string
) => (dispatch: Dispatch<Action>) => Promise<any>;

export type SetSpidIdAndSigFromUrl = (spidId: string, sig: string) => Action<'SET_SIG_AND_SPIDID_FROM_URL'>;
export type UserEntersEmail = (email: string) => Action<'USER_ENTERS_EMAIL'>;
export type UserEntersPhoneNumber = (num: string) => Action<'USER_ENTERS_PHONE_NUMBER'>;
export type UserEntersFirstName = (firstName: string) => Action<'USER_ENTERS_FIRST_NAME'>;
export type UserEntersLastName = (lastName: string) => Action<'USER_ENTERS_LAST_NAME'>;
export type UserEntersBirthDay = (birthDay: string) => Action<'USER_ENTERS_BIRTH_DAY'>;
export type UserEntersBirthMonth = (birthMonth: string) => Action<'USER_ENTERS_BIRTH_MONTH'>;
export type UserEntersBirthYear = (birthYear: string) => Action<'USER_ENTERS_BIRTH_YEAR'>;
export type UserEntersStreetAddress = (streetAddress: string) => Action<'USER_ENTERS_STREET_ADDRESS'>;
export type UserEntersCoAddress = (coAddress: string) => Action<'USER_ENTERS_CO_ADDRESS'>;
export type UserEntersHouseNumber = (houseNumber: string) => Action<'USER_ENTERS_HOUSE_NUMBER'>;
export type UserEntersEntrance = (entrance: string) => Action<'USER_ENTERS_ENTRANCE'>;
export type UserEntersFloor = (floor: string) => Action<'USER_ENTERS_FLOOR'>;
export type UserEntersApartmentNumber = (apartmentNumber: string) => Action<'USER_ENTERS_APARTMENT_NUMBER'>;
export type UserEntersZipCode = (zipCode: string) => Action<'USER_ENTERS_ZIPCODE'>;
export type UserEntersCity = (city: string) => Action<'USER_ENTERS_CITY'>;
export type UserEntersDeliveryPointId = (deliveryPointId: string) => Action<'USER_ENTERS_DELIVERY_POINT_ID'>;
export type UserEntersCode = (code: string) => Action<'USER_ENTERS_CODE'>;
export type ClearSpidToken = () => Action<'CLEAR_SPID_TOKEN'>;
export type ShowTimeout = () => Action<'SHOW_TIMEOUT'>;
export type HideTimeout = () => Action<'HIDE_TIMEOUT'>;
export type SetReferer = (referer: string) => Action<'SET_REFERER'>;
export type SetRedirectUri = (redirectUri: string) => Action<'SET_REDIRECT_URI'>;
export type SetUtmSource = (source: string) => Action<'SET_UTM_SOURCE'>;
export type SetUtmMedium = (medium: string) => Action<'SET_UTM_MEDIUM'>;
export type SetUtmCampaign = (campaign: string) => Action<'SET_UTM_CAMPAIGN'>;
export type SetUtmTerm = (term: string) => Action<'SET_UTM_TERM'>;
export type SetUtmContent = (content: string) => Action<'SET_UTM_CONTENT'>;
export type UserSetOrgnumber = (orgnumber: string) => Action<'SET_BRREG_INPUT'>;
export type UserEntersLoyaltyCode = (loyaltyCode: string) => Action<'USER_ENTERS_LOYALTY_CODE'>;

export { default as actionTypes, ActionTypes } from "./actionTypes"
export { default as addFamilySharing } from "./addFamilySharing"
export { default as cancelPayment } from "./cancelPayment"
export { default as checkCode } from "./checkCode"
export { default as checkDuplicateAndQuarantine } from "./checkDuplicateAndQuarantine"
export { default as checkError } from "./checkError"
export { default as checkProductQuarantined } from "./checkProductQuarantined"
export { default as clearSpidToken } from "./clearSpidToken"
export { default as createLink1And2AsUrlParams } from "./createLink1And2AsUrlParams"
export { default as createOrder } from "./createOrder"
export { default as createSpidUser } from "./createSpidUser"
export { default as fetchAlternateOfferProductInfo } from "./fetchAlternateOfferProductInfo"
export { default as fetchApi } from "./fetchApi"
export { default as fetchBrregInfo } from "./fetchBrregInfo"
export { default as fetchCustomerServiceInfo } from "./fetchCustomerServiceInfo"
export { default as fetchFullPriceProductInfo } from "./fetchFullPriceProductInfo"
export { default as fetchProductInfo } from "./fetchProductInfo"
export { default as fetchUpsaleProductInfo } from "./fetchUpsaleProductInfo"
export { default as fetchUserInfo } from "./fetchUserInfo"
export { default as fetchWithUuid } from "./fetchWithUuid"
export { default as findUserByEmail } from "./findUserByEmail"
export { default as findUserByPhoneNumber } from "./findUserByPhoneNumber"
export { default as getIdentity } from "./getIdentity"
export { default as hideTimeout } from "./hideTimeout"
export { default as initializeSpid } from "./initializeSpid"
export { default as loadIdentity } from "./loadIdentity"
export { default as sendSms } from "./sendSms"
export { default as setRedirectUri } from "./setRedirectUri"
export { default as setReferer } from "./setReferer"
export { default as setSpidIdAndSigFromUrl } from "./setSpidIdAndSigFromUrl"
export { default as setUtmCampaign } from "./setUtmCampaign"
export { default as setUtmContent } from "./setUtmContent"
export { default as setUtmMedium } from "./setUtmMedium"
export { default as setUtmSource } from "./setUtmSource"
export { default as setUtmTerm } from "./setUtmTerm"
export { default as showTimeout } from "./showTimeout"
export { default as spidOptions } from "./spidOptions"
export { default as strexPaymentMethod, strexMethods } from "./strexPaymentMethod"
export { default as userEntersApartmentNumber } from "./userEntersApartmentNumber"
export { default as userEntersBirthDay } from "./userEntersBirthDay"
export { default as userEntersBirthMonth } from "./userEntersBirthMonth"
export { default as userEntersBirthYear } from "./userEntersBirthYear"
export { default as userEntersCity } from "./userEntersCity"
export { default as userEntersCoAddress } from "./userEntersCoAddress"
export { default as userEntersCode } from "./userEntersCode"
export { default as userEntersDeliveryPointId } from "./userEntersDeliveryPointId"
export { default as userEntersEmail } from "./userEntersEmail"
export { default as userEntersEntrance } from "./userEntersEntrance"
export { default as userEntersFirstName } from "./userEntersFirstName"
export { default as userEntersFloor } from "./userEntersFloor"
export { default as userEntersHouseNumber } from "./userEntersHouseNumber"
export { default as userEntersLastName } from "./userEntersLastName"
export { default as userEntersLoyaltyCode } from "./userEntersLoyaltyCode"
export { default as userEntersPhoneNumber } from "./userEntersPhoneNumber"
export { default as userEntersStreetAddress } from "./userEntersStreetAddress"
export { default as userEntersZipCode } from "./userEntersZipCode"
export { default as userSetOrgnumber } from "./userSetOrgnumber"
export { default as validateLoyaltyCode } from "./validateLoyaltyCode"
export { default as windowUuid } from "./windowUuid"
